// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.FaqLayout_faq-layout__xT5lS {
  display: grid;
  grid-template-columns: 290px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}
@media (max-width: 1080px) {
  .FaqLayout_faq-layout__xT5lS {
    grid-template-columns: 1fr;
  }
}

.FaqLayout_faq-nav__wsz46 {
  position: sticky;
  top: 108px;
  background: #F7F5F1;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 24px;
  padding: 20px;
  box-shadow: 0 18px 48px rgba(18, 34, 29, 0.04);
  display: grid;
  gap: 10px;
}
@media (max-width: 1080px) {
  .FaqLayout_faq-nav__wsz46 {
    position: static;
  }
}
.FaqLayout_faq-nav__title__jimET {
  margin: 0 0 6px;
  font-size: 14px;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6A6E67;
}
.FaqLayout_faq-nav__link__LGRqs {
  display: block;
  padding: 12px 14px;
  border-radius: 16px;
  color: #13231D;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  line-height: 1.45;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.FaqLayout_faq-nav__link__LGRqs:hover {
  background: rgba(130, 177, 148, 0.12);
}

.FaqLayout_faq-groups__66Xos {
  display: grid;
  gap: 18px;
}

.FaqLayout_faq-group__X51lg {
  background: #F7F5F1;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 32px;
  padding: 28px;
  box-shadow: 0 18px 48px rgba(18, 34, 29, 0.04);
  scroll-margin-top: 108px;
}
.FaqLayout_faq-group__title__sgKhF {
  margin: 0 0 20px;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: -0.045em;
  color: #13231D;
  line-height: 1.08;
}
@media (max-width: 720px) {
  .FaqLayout_faq-group__title__sgKhF {
    font-size: 30px;
  }
}
.FaqLayout_faq-group__intro__H1Jyl {
  margin: 0 0 22px;
  max-width: 62ch;
  color: rgba(19, 35, 29, 0.68);
  font-size: 15px;
  line-height: 1.75;
}

/* ACCORDION ITEMS */
.FaqLayout_faq-list__4t4ns {
  display: grid;
  gap: 12px;
}

.FaqLayout_faq-item__1xTR4 {
  background: #FBFAF7;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 22px;
  overflow: hidden;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}
.FaqLayout_faq-item__1xTR4[open] {
  background: #fcfbf8;
  border-color: rgba(130, 177, 148, 0.32);
}
.FaqLayout_faq-item__header__0oQp- {
  list-style: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
}
.FaqLayout_faq-item__header__0oQp-::-webkit-details-marker {
  display: none;
}
.FaqLayout_faq-item__question__qXOGs {
  font-size: 16px;
  font-weight: 600;
  color: #13231D;
  line-height: 1.62;
}
.FaqLayout_faq-item__icon__dVcpV {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #13231D;
  font-size: 18px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.14);
  font-weight: 500;
  line-height: 1;
  transition: transform 0.2s ease, background-color 0.2s ease;
}
.FaqLayout_faq-item__1xTR4[open] .FaqLayout_faq-item__icon__dVcpV {
  transform: rotate(45deg);
  background: rgba(130, 177, 148, 0.22);
}
.FaqLayout_faq-item__answer__hX8qq {
  padding: 0 20px 20px;
}
.FaqLayout_faq-item__answer__hX8qq p {
  margin: 0;
  color: rgba(19, 35, 29, 0.68);
  font-size: 15px;
  line-height: 1.8;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/FAQsPage/FaqLayout/FaqLayout.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACI,aAAA;EACA,2CAAA;EACA,SAAA;EACA,kBAAA;AAiBJ;AAfI;EANJ;IAOQ,0BAAA;EAkBN;AACF;;AAfA;EACI,gBAAA;EACA,UAAA;EACA,mBDGmB;ECFnB,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,8CDyES;ECxET,aAAA;EACA,SAAA;AAkBJ;AAhBI;EAXJ;IAYQ,gBAAA;EAmBN;AACF;AAjBI;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAmBR;AAhBI;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,cDlBe;ECmBf,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,uDAAA;AAkBR;AAhBQ;EACI,qCAAA;AAkBZ;;AAbA;EACI,aAAA;EACA,SAAA;AAgBJ;;AAbA;EACI,mBD1CmB;EC2CnB,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,8CD4BS;EC3BT,wBAAA;AAgBJ;AAdI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cDjDe;ECkDf,iBAAA;AAgBR;AAdQ;EARJ;IASQ,eAAA;EAiBV;AACF;AAdI;EACI,gBAAA;EACA,eAAA;EACA,6BD1De;EC2Df,eAAA;EACA,iBAAA;AAgBR;;AAZA,oBAAA;AACA;EACI,aAAA;EACA,SAAA;AAeJ;;AAZA;EACI,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,8DAAA;AAeJ;AAbI;EACI,mBAAA;EACA,uCAAA;AAeR;AAZI;EACI,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAcR;AAZQ;EACI,aAAA;AAcZ;AAVI;EACI,eAAA;EACA,gBAAA;EACA,cDrGe;ECsGf,iBAAA;AAYR;AATI;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cD/Ge;ECgHf,eAAA;EACA,cAAA;EACA,oBAAA;EACA,qCAAA;EACA,gBAAA;EACA,cAAA;EACA,2DAAA;AAWR;AATQ;EACI,wBAAA;EACA,qCAAA;AAWZ;AAPI;EACI,oBAAA;AASR;AARQ;EACI,SAAA;EACA,6BDhIW;ECiIX,eAAA;EACA,gBAAA;AAUZ","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../../assets/styles/variables';\n\n.faq-layout {\n    display: grid;\n    grid-template-columns: 290px minmax(0, 1fr);\n    gap: 24px;\n    align-items: start;\n\n    @media (max-width: 1080px) {\n        grid-template-columns: 1fr;\n    }\n}\n\n.faq-nav {\n    position: sticky;\n    top: 108px;\n    background: $color-surface;\n    border: 1px solid $border-soft;\n    border-radius: 24px;\n    padding: 20px;\n    box-shadow: $shadow-soft;\n    display: grid;\n    gap: 10px;\n\n    @media (max-width: 1080px) {\n        position: static;\n    }\n\n    &__title {\n        margin: 0 0 6px;\n        font-size: 14px;\n        line-height: 1.3;\n        font-weight: 700;\n        letter-spacing: .12em;\n        text-transform: uppercase;\n        color: #6A6E67;\n    }\n\n    &__link {\n        display: block;\n        padding: 12px 14px;\n        border-radius: 16px;\n        color: $text-main;\n        font-size: 14px;\n        font-weight: 600;\n        text-decoration: none;\n        line-height: 1.45;\n        transition: background-color .2s ease, color .2s ease;\n\n        &:hover {\n            background: rgba(130, 177, 148, 0.12);\n        }\n    }\n}\n\n.faq-groups {\n    display: grid;\n    gap: 18px;\n}\n\n.faq-group {\n    background: $color-surface;\n    border: 1px solid $border-soft;\n    border-radius: 32px;\n    padding: 28px;\n    box-shadow: $shadow-soft;\n    scroll-margin-top: 108px;\n\n    &__title {\n        margin: 0 0 20px;\n        font-size: 36px;\n        font-weight: 800;\n        letter-spacing: -0.045em;\n        color: $text-main;\n        line-height: 1.08;\n\n        @media (max-width: 720px) {\n            font-size: 30px;\n        }\n    }\n\n    &__intro {\n        margin: 0 0 22px;\n        max-width: 62ch;\n        color: $text-secondary;\n        font-size: 15px;\n        line-height: 1.75;\n    }\n}\n\n/* ACCORDION ITEMS */\n.faq-list {\n    display: grid;\n    gap: 12px;\n}\n\n.faq-item {\n    background: #FBFAF7; \n    border: 1px solid $border-soft;\n    border-radius: 22px;\n    overflow: hidden;\n    transition: border-color .2s ease, background-color .2s ease;\n\n    &[open] {\n        background: #fcfbf8;\n        border-color: rgba(130, 177, 148, 0.32);\n    }\n\n    &__header {\n        list-style: none;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 18px;\n        padding: 18px 20px;\n\n        &::-webkit-details-marker {\n            display: none;\n        }\n    }\n\n    &__question {\n        font-size: 16px;\n        font-weight: 600;\n        color: $text-main;\n        line-height: 1.62;\n    }\n\n    &__icon {\n        width: 30px;\n        height: 30px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        color: $text-main;\n        font-size: 18px;\n        flex: 0 0 auto;\n        border-radius: 999px;\n        background: rgba(130, 177, 148, .14);\n        font-weight: 500;\n        line-height: 1;\n        transition: transform .2s ease, background-color .2s ease;\n\n        .faq-item[open] & {\n            transform: rotate(45deg);\n            background: rgba(130, 177, 148, 0.22);\n        }\n    }\n\n    &__answer {\n        padding: 0 20px 20px;\n        p {\n            margin: 0;\n            color: $text-secondary;\n            font-size: 15px;\n            line-height: 1.8;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faq-layout": `FaqLayout_faq-layout__xT5lS`,
	"faq-nav": `FaqLayout_faq-nav__wsz46`,
	"faq-nav__title": `FaqLayout_faq-nav__title__jimET`,
	"faq-nav__link": `FaqLayout_faq-nav__link__LGRqs`,
	"faq-groups": `FaqLayout_faq-groups__66Xos`,
	"faq-group": `FaqLayout_faq-group__X51lg`,
	"faq-group__title": `FaqLayout_faq-group__title__sgKhF`,
	"faq-group__intro": `FaqLayout_faq-group__intro__H1Jyl`,
	"faq-list": `FaqLayout_faq-list__4t4ns`,
	"faq-item": `FaqLayout_faq-item__1xTR4`,
	"faq-item__header": `FaqLayout_faq-item__header__0oQp-`,
	"faq-item__question": `FaqLayout_faq-item__question__qXOGs`,
	"faq-item__icon": `FaqLayout_faq-item__icon__dVcpV`,
	"faq-item__answer": `FaqLayout_faq-item__answer__hX8qq`
};
export default ___CSS_LOADER_EXPORT___;
